import { render, staticRenderFns } from "./MovieList.vue?vue&type=template&id=348aef3c&scoped=true"
import script from "./MovieList.vue?vue&type=script&lang=js"
export * from "./MovieList.vue?vue&type=script&lang=js"
import style0 from "./MovieList.vue?vue&type=style&index=0&id=348aef3c&prod&scoped=true&lang=css"
import style1 from "./MovieList.vue?vue&type=style&index=1&id=348aef3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348aef3c",
  null
  
)

export default component.exports